<!-- <script setup lang="ts">
// import LanguageSwitcher from './LanguageSwitcher.vue'
// import Logo from '@/assets/logo.svg'

</script> -->

<template>
  <header class="fixed-top" style="z-index: 100;">
    <nav class="container navbar navbar-expand-lg">
      <div class="container-fluid">
        <a class="navbar-brand" href="/">
          <img src="@/assets/images/logo_full.png" class="logo img-fluid" alt="Qihuang.AI" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div id="navbarNav" class="collapse navbar-collapse"
          :class="{ 'navbar-light': true }">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <a class="nav-link" href="https://www.qihuang.top/qixiaohuang.html" target="_blank" >产品介绍</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/chat" target="_blank" >岐黄问答</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/ai-doctors" target="_blank" >数智郎中</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://www.qihuang.top/news.html" target="_blank">新闻中心</a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="https://www.qihuang.top/about.html" target="_blank">关于我们</a>
            </li>
            <!-- <li class="nav-item" style="width: 50px;">
            </li>
            <li class="nav-item d-flex" data-bs-toggle="collapse">
              <LanguageSwitcher />
              <img src="/images/avatar.png" class="avatar" alt="avatar" />
            </li> -->
          </ul>
        </div>
      </div>
    </nav>
  </header>
</template>
<style lang="scss" scoped>
header {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(12px) brightness(100%);
  box-shadow: 0 1px 4px #0c0c0d0d;
  padding: 0 16px;

  .logo {
    width: 120px;
  }

  .avatar {
    width: 33px;
    height: 33px;
  }

  .navbar-light {
    color: #fff;
  }

  .navbar-dark {
    color: #000;
  }

  a,
  span {
    
    font-size: 14px !important;
    line-height: 22px !important;
  }
}
</style>
